export function validateForm(inputs) {
  let isValid = null;

  inputs.forEach((input) => {
    if (input.current.type === "checkbox") {
      if (!input.current.checked) {
        isValid = false;
        input.current.classList.add("error");
      } else {
        isValid = true;
        input.current.classList.remove("error");
      }
    } else {
      if (!input.current.value.trim()) {
        isValid = false;
        input.current.classList.add("error");
        input.current.nextElementSibling.innerHTML = "Заполните это поле";
      } else if (input.current.value.trim().length <= 2) {
        isValid = false;
        input.current.classList.add("error");
        input.current.nextElementSibling.innerHTML =
          "Поле должно содержать не менее 3 символов";
      } else {
        isValid = true;
        input.current.classList.remove("error");
        input.current.nextElementSibling.innerHTML = "";
      }
    }
  });

  return isValid;
}
